import type { z } from 'zod';
import type { QueryClient } from '@tanstack/react-query';

export interface ToolConfig<T extends z.ZodType = z.ZodType, R = unknown> {
  name: string;
  description: string;
  inputSchema: T;
  execute: (params: z.infer<T>, queryClient: QueryClient) => Promise<R>;
}

/**
 * Binds a queryClient to a ToolConfig, producing the shape that
 * `registerTool()` from @getdutchie/agent-react expects.
 */
export function createTool<T extends z.ZodType, R>(
  config: ToolConfig<T, R>,
  queryClient: QueryClient,
) {
  return {
    name: config.name,
    description: config.description,
    inputSchema: config.inputSchema,
    execute: (params: z.infer<T>) => config.execute(params, queryClient),
  };
}
